import { useCallback, useMemo } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navigation } from '@pcmp/react-coworker-components';
import { useModal } from '@pcmp/react-providers';
import { AvatarProps } from '@ingka/avatar';

import { ROUTES } from '@/lib/constants';
import { useGetV1UsersMeQuery } from '@/redux/apis/frontend-api';
import { initials } from '@/lib/utils/string';
import { UserProfileSider } from '@/components/siders/user-profile';

import './index.module.css';
import MaintenanceBanner from './maintenance-banner';

const { TopNavItem, NavItemContainer, TopNavigation } = Navigation;

export const Header = () => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname: route } = useLocation();
  const { data: user } = useGetV1UsersMeQuery();
  const { openModal } = useModal();
  const navigateTo = useCallback(
    (path: string) => () => navigate(path),
    [navigate]
  );
  const handleOpenUserProfile = useCallback(() => {
    openModal({
      component: UserProfileSider,
      props: {},
    });
  }, [openModal]);
  const avatar: AvatarProps = useMemo(
    () =>
      user
        ? {
            text: initials(user.fullName).slice(0, 2),
            screenReaderText: user.fullName,
            onClick: handleOpenUserProfile,
          }
        : {
            screenReaderText: t('label.loading'),
            withIcon: true,
          },
    [user, handleOpenUserProfile, t]
  );
  const isMobile = width < 640;

  return (
    <div data-testid="header" className="sticky top-0 left-0 w-full z-40">
      <MaintenanceBanner />
      <TopNavigation
        title="QR Tool"
        avatar={avatar}
        onTitleClick={navigateTo('/')}
      >
        <NavItemContainer>
          {ROUTES.map(({ path, translationKey, icon, className }) => (
            <div className={isMobile ? '' : className} key={path}>
              <TopNavItem
                key={path}
                text={t(translationKey)}
                icon={icon}
                onClick={navigateTo(path)}
                active={route === path}
              />
            </div>
          ))}
        </NavItemContainer>
      </TopNavigation>
    </div>
  );
};
